(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-ticker"] && !Shopify.designMode) return;
  try {
    
/**
 * SALES TICKER v3 — Motor de Simulación Inteligente
 *
 * Arquitectura: Custom Element (HTMLElement)
 * Patrón:       Module pattern encapsulado por instancia
 * Tamaño:       < 5 KB minificado
 */
(function () {
  'use strict';

  /* ── Utilidades puras (sin efectos secundarios) ──── */

  /** Fisher-Yates in-place shuffle */
  function shuffle(arr) {
    var i = arr.length, j, t;
    while (i > 0) {
      j = Math.random() * i-- | 0;
      t = arr[i]; arr[i] = arr[j]; arr[j] = t;
    }
    return arr;
  }

  /** Limitar palabras */
  function limitWords(str, n) {
    if (!n) return str;
    var w = str.split(' ');
    return w.length <= n ? str : w.slice(0, n).join(' ') + '\u2026';
  }

  /** Tiempo aleatorio legible en español */
  function randomTime(min, max) {
    var m = (Math.random() * (max - min) + min) | 0;
    if (m >= 60) {
      var h = (m / 60) | 0;
      return 'Hace ' + h + (h === 1 ? ' hora' : ' horas');
    }
    return 'Hace ' + m + (m === 1 ? ' minuto' : ' minutos');
  }

  /** Multiplicador de intervalo según franja horaria */
  function hourMultiplier(intensity) {
    var h = new Date().getHours();
    var factor = h < 6 ? 2.5 : h < 9 ? 2.0 : h < 12 ? 1.3
               : h < 14 ? 0.7 : h < 18 ? 1.0 : h < 22 ? 0.5 : 2.5;
    return factor / Math.max(1, intensity);
  }

  /** localStorage con fallback silencioso */
  var store = {
    get: function (k) {
      try { return JSON.parse(localStorage.getItem(k)); } catch (_) { return null; }
    },
    set: function (k, v) {
      try { localStorage.setItem(k, JSON.stringify(v)); } catch (_) {}
    }
  };

  /** Escape HTML para prevenir XSS en datos de settings */
  function escapeHTML(s) {
    var d = document.createElement('div');
    d.appendChild(document.createTextNode(String(s)));
    return d.innerHTML;
  }

  /** Limpiar array de strings (trim + filtrar vacíos) */
  function clean(arr) {
    return Array.isArray(arr)
      ? arr.map(function (s) { return String(s).trim(); }).filter(Boolean)
      : [];
  }

  /* ── Clase SalesTickerController ─────────────────── */

  function SalesTickerController(el) {
    this.el  = el;
    this.sid = el.id; // "sales-ticker-{section.id}"

    /* Parsear configuración */
    var raw = {};
    try { raw = JSON.parse(el.dataset.config || '{}'); } catch (_) {}

    this.cfg = {
      pos    : raw.pos   || 'bottom_left',
      anim   : raw.anim  || 'fade_slide',
      vt     : raw.vt    || 6000,
      iv     : raw.iv    || 15000,
      si     : raw.si    || 400,
      so     : raw.so    || 400,
      names  : clean(raw.names),
      cities : clean(raw.cities),
      acts   : clean(raw.acts),
      msgs   : clean(raw.msgs),
      mf     : raw.mf    || 3,
      sv     : !!raw.sv,
      vl     : raw.vl    || '\u2713 Verificado',
      tmin   : raw.tmin  || 2,
      tmax   : raw.tmax  || 60,
      dist   : raw.dist  || 'smart',
      rh     : !!raw.rh,
      ix     : raw.ix    || 1,
      spn    : !!raw.spn,
      pn     : raw.pn    || '',
      pw     : raw.pw    || 0,
      pb     : !!raw.pb,
      img    : !!raw.img
    };

    /* Validar datos mínimos */
    if (!this.cfg.names.length || !this.cfg.cities.length || !this.cfg.acts.length) {
      return;
    }

    /* Referencias DOM */
    var popId = 'sales-ticker-popup-' + this.sid.replace('sales-ticker-', '');
    this.pop  = document.getElementById(popId);
    if (!this.pop) return;

    this.slots = {
      img  : this.pop.querySelector('.sales-ticker__img-slot'),
      text : this.pop.querySelector('.sales-ticker__text'),
      prod : this.pop.querySelector('.sales-ticker__product'),
      time : this.pop.querySelector('.sales-ticker__time'),
      badge: this.pop.querySelector('.sales-ticker__badge'),
      close: this.pop.querySelector('.sales-ticker__close')
    };

    /* Imagen pre-renderizada desde <template> */
    var tmpl = document.getElementById('sales-ticker-img-' + this.sid.replace('sales-ticker-', ''));
    this.imgHTML = (tmpl && this.cfg.img) ? tmpl.innerHTML : '';

    /* Estado de secuencia (con persistencia) */
    this.seq = this._loadSequence();

    /* Estado de ejecución */
    this._paused  = false;
    this._visible = false;
    this._count   = 0;
    this._recent  = [];
    this._tShow   = null;
    this._tHide   = null;

    this._bindEvents();
    this._scheduleNext(true);
  }

  /* ── Persistencia de secuencia ───────────────────── */

  SalesTickerController.prototype._loadSequence = function () {
    var cfg = this.cfg;
    var key = 'st3_' + this.sid;
    var s   = store.get(key);

    /* Invalidar si cambió la cantidad de datos */
    if (s && s.nl === cfg.names.length
          && s.cl === cfg.cities.length
          && s.al === cfg.acts.length) {
      return s;
    }

    var seq = {
      nl: cfg.names.length,
      cl: cfg.cities.length,
      al: cfg.acts.length,
      n:  shuffle(cfg.names.slice()),
      c:  shuffle(cfg.cities.slice()),
      a:  shuffle(cfg.acts.slice()),
      m:  shuffle(cfg.msgs.slice()),
      ni: 0, ci: 0, ai: 0, mi: 0
    };
    store.set(key, seq);
    return seq;
  };

  SalesTickerController.prototype._saveSequence = function () {
    store.set('st3_' + this.sid, this.seq);
  };

  /* ── Consumir elemento de lista circular ─────────── */

  SalesTickerController.prototype._next = function (listKey, idxKey, source) {
    var seq = this.seq;
    if (seq[idxKey] >= seq[listKey].length) {
      seq[listKey] = shuffle(source.slice());
      seq[idxKey]  = 0;
    }
    return seq[listKey][seq[idxKey]++];
  };

  /* ── Construir datos de notificación ─────────────── */

  SalesTickerController.prototype._buildNotification = function () {
    var cfg = this.cfg;
    var hasMsgs = cfg.msgs.length > 0;

    this._count++;

    if (hasMsgs && this._count % cfg.mf === 0) {
      return this._buildCustom();
    }
    return this._buildPurchase();
  };

  SalesTickerController.prototype._buildPurchase = function () {
    var cfg    = this.cfg;
    var name, city, act, combo;
    var tries  = 20;

    do {
      name  = this._next('n', 'ni', cfg.names);
      city  = this._next('c', 'ci', cfg.cities);
      act   = this._next('a', 'ai', cfg.acts);
      combo = name + '\x00' + city + '\x00' + act;
      tries--;
    } while (
      cfg.dist === 'smart' &&
      this._recent.indexOf(combo) !== -1 &&
      tries > 0
    );

    this._recent.push(combo);
    if (this._recent.length > 30) this._recent.shift();
    this._saveSequence();

    return {
      type  : 'purchase',
      name  : name,
      city  : city,
      act   : act,
      time  : randomTime(cfg.tmin, cfg.tmax)
    };
  };

  SalesTickerController.prototype._buildCustom = function () {
    var msg = this._next('m', 'mi', this.cfg.msgs);
    this._saveSequence();
    return { type: 'custom', text: msg };
  };

  /* ── Renderizar en el DOM ────────────────────────── */

  SalesTickerController.prototype._render = function (data) {
    var cfg   = this.cfg;
    var slots = this.slots;
    var pop   = this.pop;

    pop.classList.toggle('sales-ticker__popup--custom', data.type === 'custom');

    if (data.type === 'custom') {
      slots.img.innerHTML   = '';
      slots.text.innerHTML  = escapeHTML(data.text);
      slots.prod.textContent = '';
      slots.time.textContent = '';
      slots.badge.textContent = '';
      return;
    }

    /* Imagen */
    slots.img.innerHTML = this.imgHTML;

    /* Texto principal: "Nombre de Ciudad acción" */
    slots.text.innerHTML =
      '<span class="sales-ticker__name">'  + escapeHTML(data.name) + '</span>' +
      ' de ' +
      '<span class="sales-ticker__city">'  + escapeHTML(data.city) + '</span>' +
      ' ' + escapeHTML(data.act);

    /* Nombre del producto */
    if (cfg.spn && cfg.pn) {
      slots.prod.textContent    = limitWords(cfg.pn, cfg.pw);
      slots.prod.style.fontWeight = cfg.pb ? '700' : '400';
      slots.prod.hidden = false;
    } else {
      slots.prod.hidden = true;
    }

    /* Tiempo y badge */
    slots.time.textContent  = data.time;
    slots.badge.textContent = cfg.sv ? cfg.vl : '';
  };

  /* ── Ciclo de vida: mostrar / ocultar ────────────── */

  SalesTickerController.prototype._show = function () {
    if (this._paused) return;

    this._render(this._buildNotification());

    /* Quitar hidden antes de la transición */
    this.pop.hidden = false;
    this.pop.setAttribute('aria-hidden', 'false');
    this._visible = true;

    /* Doble rAF: garantiza que el navegador procese el estado inicial
       antes de aplicar la clase de transición (evita flash sin animación) */
    var pop = this.pop;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pop.classList.add('is-visible');
      });
    });

    var self = this;
    this._tHide = setTimeout(function () { self._hide(); }, this.cfg.vt);
  };

  SalesTickerController.prototype._hide = function () {
    var self = this;
    var pop  = this.pop;

    pop.classList.remove('is-visible');
    pop.setAttribute('aria-hidden', 'true');
    this._visible = false;

    /* Esperar a que termine la transición de salida antes de ocultar */
    this._tShow = setTimeout(function () {
      pop.hidden = true;
      self._scheduleNext(false);
    }, this.cfg.so + 50);
  };

  SalesTickerController.prototype._scheduleNext = function (isFirst) {
    var self = this;
    var iv   = this.cfg.iv;

    if (this.cfg.rh) {
      iv = Math.max(4000, Math.round(iv * hourMultiplier(this.cfg.ix)));
    }

    /* Primer delay de 2 s para no competir con el LCP */
    var delay = isFirst ? 2000 : iv;

    this._tShow = setTimeout(function () {
      if (!self._paused) self._show();
    }, delay);
  };

  /* ── Eventos ─────────────────────────────────────── */

  SalesTickerController.prototype._bindEvents = function () {
    var self = this;

    /* Cerrar manualmente */
    if (this.slots.close) {
      this.slots.close.addEventListener('click', function () {
        clearTimeout(self._tHide);
        clearTimeout(self._tShow);
        self._hide();
      });
    }

    /* Visibility API — pausar cuando la pestaña está en segundo plano */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self._paused = true;
        clearTimeout(self._tHide);
        clearTimeout(self._tShow);
        if (self._visible) {
          self.pop.classList.remove('is-visible');
          self.pop.setAttribute('aria-hidden', 'true');
          self._visible = false;
        }
      } else {
        self._paused = false;
        /* Pequeño delay al volver para no interrumpir al usuario */
        self._tShow = setTimeout(function () {
          self._scheduleNext(false);
        }, 1500);
      }
    });
  };

  /* ── Custom Element ──────────────────────────────── */

  /**
   * Usar un Custom Element (en lugar de querySelector genérico) permite:
   * - Inicialización automática al insertar el elemento en el DOM
   * - Compatible con Theme Editor (secciones dinámicas)
   * - Patrón oficial recomendado por Shopify para OS 2.0
   */
  if (!customElements.get('sales-ticker')) {
    customElements.define('sales-ticker', class extends HTMLElement {
      connectedCallback() {
        /* Diferir hasta que el parser haya procesado los hijos del elemento */
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', this._init.bind(this), { once: true });
        } else {
          this._init();
        }
      }

      _init() {
        if (this._controller) return; // evitar doble init
        this._controller = new SalesTickerController(this);
      }

      disconnectedCallback() {
        /* Limpiar timers al remover la sección desde el editor */
        if (this._controller) {
          clearTimeout(this._controller._tShow);
          clearTimeout(this._controller._tHide);
        }
      }
    });
  }

})();

  } catch(e) { console.error(e); }
})();
})();
